(() => {
  document.documentElement.classList.add('js');
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const root = select.closest('[data-product-root]');
    const option = select.selectedOptions[0];
    const available = option.dataset.available === 'true';
    root.querySelector('[data-add]').disabled = !available;
    root.querySelectorAll('[data-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variantId === select.value)));
    root.querySelector('[data-add-label]').textContent = available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
    root.querySelector('[data-product-price]').textContent = option.dataset.price;
    root.querySelector('[data-compare-price]').textContent = option.dataset.compare;
    const variants = JSON.parse(root.querySelector('[data-variant-data]').textContent);
    const variant = variants.find(item => String(item.id) === select.value);
    if (variant) {
      const qty = root.querySelector('[data-quantity]');
      qty.min = variant.min; qty.step = variant.step; qty.value = variant.min;
      if (variant.max) qty.max = variant.max; else qty.removeAttribute('max');
      const img = root.closest('section')?.querySelector('[data-featured-image] img');
      if (img && variant.image) { img.removeAttribute('srcset'); img.src = variant.image; }
    }
    if (root.closest('.product-page')) {
      const url = new URL(location.href); url.searchParams.set('variant',select.value);
      history.replaceState({}, '', url);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open], .nav-submenu[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    const variantButton = event.target.closest('[data-variant-id]');
    if (variantButton) { const select = variantButton.closest('[data-product-root]').querySelector('[data-variant-select]'); select.value = variantButton.dataset.variantId; select.dispatchEvent(new Event('change', {bubbles:true})); }
    const format = event.target.closest('[data-format-target]');
    if (format) {
      const section = format.closest('[data-quick-buy]');
      const panel = document.getElementById(format.dataset.formatTarget);
      if (panel && section.contains(panel)) {
        event.preventDefault();
        section.querySelectorAll('[data-quick-panel]').forEach(el => el.hidden = el !== panel);
        section.querySelectorAll('[data-format-target]').forEach(el => { el.classList.toggle('active',el === format); if(el === format)el.setAttribute('aria-current','true'); else el.removeAttribute('aria-current'); });
        const img = section.querySelector('[data-featured-image] img');
        if (img && panel.dataset.productImage) { img.removeAttribute('srcset'); img.src = panel.dataset.productImage; img.alt = panel.dataset.productTitle; }
        panel.querySelector('[data-variant-select]').dispatchEvent(new Event('change', {bubbles:true}));
      }
    }

    if (event.target.closest('.mobile-nav a')) event.target.closest('.mobile-nav').open = false;
    document.querySelectorAll('.nav-submenu[open],.mobile-nav[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
})();
